// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-stack.js';

import { paths } from '../generated/file-stack';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-stack', Original, paths);
